import {
  resetSubscriptionStore,
  useAchievements,
  useBreathworks,
  useFeelings,
  useJourneys,
  useWorkouts,
} from '@breath-lab/state';
import { clearSessionTokenCache } from '../domain/sessionTokenCache';

export function bootstrapUser(uid: string): void {
  useFeelings.getState().load();
  useAchievements.getState().startListening(uid);
  useBreathworks.getState().load();
  useJourneys.getState().load(uid);
}

// Clears user-specific stores on sign-out.
// useBreathworks and useFeelings are intentionally NOT reset here — they hold
// public data that is identical across users, so persisting them avoids an
// unnecessary Firestore re-read on the next login.
export function teardownUser(): void {
  useAchievements.getState().stopListening();
  useJourneys.getState().reset();
  useWorkouts.getState().reset();
  resetSubscriptionStore();
  clearSessionTokenCache();
}
